import React, { memo } from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './darkenBackground.module.scss';

const DarkendBackground = memo(({ isDarkened }) =>
    <CSSTransition
        classNames={{
            enter: `${styles.backgroundEnter}`,
            enterActive: `${styles.backgroundActiveEnter}`,
            enterDone: `${styles.backgroundDoneEnter}`,
            exit: `${styles.backgroundExit}`,
            exitActive: `${styles.backgroundActiveExit}`,
            exitDone: `${styles.backgroundDoneExit}`,
        }}
        in={isDarkened}
        key="background"
        unmountOnExit
        timeout={500}
    >
        <div key="background" />
    </CSSTransition>
);

export default DarkendBackground;
